import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import { CandidateCard } from 'src/app/public/app/models/candidateCard';
import { CandidateCardQueryFilter } from 'src/app/public/app/models/candidateCardQueryFilter';
import { JobMatchQueryFilter } from 'src/app/core/models/jobMatchQueryFilter';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { RunCandidateScore } from 'src/app/core/models/runCandidateScore';
import { FormalizeCandidate, FormalizeCompany } from 'src/app/core/models/formalizePayload';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { BsModalService, PopoverDirective } from 'ngx-bootstrap';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { CandidateCardActionsModalComponent } from './candidate-card-actions-modal/candidate-card-actions-modal.component';
import { WebSocketsService } from 'src/app/core/services/web-sockets.service';
import { SharedAjsService } from 'src/app/core/services/shared-ajs.service';
import { JobMatchActionsService } from 'src/app/core/services/job-match-actions.service';

declare var libphonenumber: any;
declare var bootbox: any;

@Component({
  selector: 'app-candidate-card',
  templateUrl: './candidate-card.component.html',
  styleUrls: ['./candidate-card.component.css']
})
export class CandidateCardComponent implements OnInit, OnDestroy {

  @Input() candidateInfo: any;
  @Input() filterParams: any;
  @Input() activityMap: any;
  @Input() salaryDurationOptions: any;
  @Input() candidateType: any;
  @Input() userId: any;
  @Input() jobMatchesPopoverPosition: any;
  @Input() jobTypeList: any;
  @Input() jobMatchesActiveTab: any;
  @Input() isRowViewActive: any;
  @Input() allVendors: any;
  @Output() setCandidateInfo = new EventEmitter<any>();
  @Output() deleteCallback = new EventEmitter<any>();

  @ViewChildren('jobMatchesPopoverDirective') jobMatchesPopoverDirectives!: QueryList<PopoverDirective>;

  candidate: any = null;
  candidateJobMatches: any = [];
  notifications: any = [];
  newNotifications: any = [];
  showCurrentJobDetails = false;
  notificationsSearchObject: any = {};
  userNotificationControls: any = {};
  recentActivitiesControls: any = {};
  isActivityClicked = false;
  jobMatchesObject: any = {};
  numberOfNewNotifications = 0;
  recentActivities: any = [];
  clientOrBuLabel = 'Client';
  filledOrJoinedText = '';
  isUserAdmin = false;
  isSuperUser = false;
  is4dot5UserAdmin = false;
  isNotificationClicked = false;
  userName = '';

  loadingFlag = true;
  hasCandidateJoined = false;
  showAdditionalDetailsIcons = false;
  filtersEnabled = false;
  showFilledOrJoinedHeader = false;
  showFilledOrJoinedOnCard = false;
  showSalary = true;
  showNotificationsFlag = false;
  showRecentActivitiesFlag = false;

  candidateCardActionsModal: any;
  candidateCardCommunicationModal: any;
  candidateCardPeerCommunicationModal: any;
  candidateCardNotesModal: any;
  candidateCardShowAllActivitiesModal: any;

  private incomingChatMessageSubscription!: Subscription;
  private refreshCandidateCardSubscription!: Subscription;

  constructor(
    @Inject(WebSocketsService) private webSocketsService: WebSocketsService,
    private candidateService: CandidateService,
    private jobMatchService: JobMatchService,
    private jobService: JobService,
    private userRoleService: UserRoleService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private resumeService: ResumeService,
    private jobMatchActionsService: JobMatchActionsService,
    @Inject(SharedAjsService) private sharedAjsService: SharedAjsService,
    private sharedService: SharedService,
    private authService: AuthService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.candidate = null;
    this.candidateJobMatches = [];
    this.notifications = [];
    this.newNotifications = [];
    this.showCurrentJobDetails = false;
    this.notificationsSearchObject = {};
    this.userNotificationControls = {};
    this.recentActivitiesControls = {};
    this.recentActivitiesControls.activityClickCount = 0;
    this.isActivityClicked = false;
    this.jobMatchesObject = {};
    this.numberOfNewNotifications = 0;
    this.recentActivities = [];
    this.clientOrBuLabel = 'Client';
    this.filledOrJoinedText = '';
    this.isUserAdmin = false;

    this.loadingFlag = true;
    this.hasCandidateJoined = false;
    this.showAdditionalDetailsIcons = false;
    this.filtersEnabled = false;
    this.showFilledOrJoinedHeader = false;
    this.showFilledOrJoinedOnCard = false;
    this.showSalary = true;
    this.showNotificationsFlag = false;
    this.showRecentActivitiesFlag = false;

    this.listenToIncomingChatMessage();
    this._subscribeToCandidateCardRefreshEvent();
    this.init(false);
  }

  init(isRefresh: boolean) {
    const userDetails = this.authService.getUserDetails();
    this.userName = userDetails.firstname + ' ' + userDetails.lastname;
    if (userDetails.company.companyType === MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
      this.clientOrBuLabel = 'BU';
    }
    this.candidate = new CandidateCard();
    if (this.filterParams === undefined) {
      this.filterParams = new CandidateCardQueryFilter(userDetails.company.companyId, userDetails.id);
    }
    if (this.activityMap === undefined) {
      this.activityMap = [];
    }
    if (this.jobMatchesPopoverPosition === undefined) {
      this.jobMatchesPopoverPosition = 'bottom';
    }
    this.isUserAdmin = this.userRoleService.isLoggedInUserAnAdmin();
    this.isSuperUser = this.userRoleService.isLoggedInUserSuperUser();
    this.is4dot5UserAdmin = this.userRoleService.isLoggedInUser4dot5Admin();
    this.numberOfNewNotifications = 0;
    this.notificationsSearchObject.page = 1;
    this.notificationsSearchObject.size = 3;
    this.notificationsSearchObject.candidateId = this.candidateInfo.id;
    this.notificationsSearchObject.companyId = userDetails.company.companyId;
    this.notificationsSearchObject.notifyOn = 'CANDIDATE_CARD';
    this.userNotificationControls.setNewNotificationsAsViewed = null;
    this.userNotificationControls.notificationClickCount = 0;
    this.recentActivitiesControls.getActivities = null;
    this.showAdditionalDetailsIcons = false;
    this.showNotificationsFlag = true;
    this.showRecentActivitiesFlag = true;
    this.isNotificationClicked = false;

    this.getCandidateCardInfo(isRefresh);
  }

  private _subscribeToCandidateCardRefreshEvent() {
    this.refreshCandidateCardSubscription = this.candidateService.refreshCandidateCard.subscribe((data) => {
      if (data.candidateId == this.candidateInfo.id) {
        if ((data.type == 'candidateCard' || data.type == 'candidateJobMatchCard') && this.jobMatchesActiveTab && this.jobMatchesActiveTab.candidateInfoContainerId) {
          this.refreshCard(true, true);
        } else {
          this.refreshCard(true, false);
        }
      }
    });
  }

  private listenToIncomingChatMessage() {
    this.incomingChatMessageSubscription = this.webSocketsService.receiveMessage().subscribe((message: any) => {
      if (message.candidateId == this.candidateInfo.id) {
        this.candidate.unreadMessageCount++;
      }
    });
  }

  ngOnDestroy() {
    if (this.incomingChatMessageSubscription) {
      this.incomingChatMessageSubscription.unsubscribe();
    }
    if (this.refreshCandidateCardSubscription) {
      this.refreshCandidateCardSubscription.unsubscribe();
    }
  }

  getCandidateCardInfo(isRefresh: boolean) {
    this.loadingFlag = true;
    const userDetails = this.authService.getUserDetails();
    this.filterParams.vendorIds = this.filterParams.vendors;
    let filterParams: any = _.pick(this.filterParams, Object.keys(new CandidateCardQueryFilter(userDetails.company.companyId, userDetails.id)));
    let filterParamsCopy = _.cloneDeep(filterParams);
    this.showSalary = filterParamsCopy.candidateType == 'OWN_CANDIDATES';
    if (isRefresh) {
      filterParams = new CandidateCardQueryFilter(userDetails.company.companyId, userDetails.id);
      filterParams.candidateType = filterParamsCopy.candidateType;
    }
    this.candidateService.getCandidateCard(this.candidateInfo.id, this.userId, filterParams, (data: any) => {
      _.merge(this.candidate, data);
      this.candidate = this._massageCandidateData(this.candidate);
      this._setCardFaceInfo();
      this._setJobMatchesFilter(userDetails);
      this.loadingFlag = false;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _setCardFaceInfo() {
    if (this.filterParams.roleList.length > 0
      || this.filterParams.recruiterList.length > 0
      || this.filterParams.requisitionNumbers.length > 0
      || this.filterParams.clientOrBuList.length > 0
      || this.filterParams.requisitionStatus.length > 0
      || this.filterParams.workflowStates.length > 0) {
      this.filtersEnabled = true;
    } else {
      this.filtersEnabled = false;
    }
    if (this.filtersEnabled && (this.candidate.bestMatchJobCurrentState == 'Filled' || this.candidate.bestMatchJobCurrentState == 'Joined')) {
      this.showFilledOrJoinedOnCard = true;
    } else if (!this.filtersEnabled && this.candidate.candidateFilledOrJoinedToOwnJob) {
      this.showFilledOrJoinedOnCard = true;
    } else {
      this.showFilledOrJoinedOnCard = false;
    }

    const jobWorkLocations = this.showFilledOrJoinedOnCard ? this.candidate.filledOrJoinedMatchWorkLocations : this.candidate.bestJobMatchWorkLocations;
    this.candidate.workLocationsMatchStatus = this.jobMatchService.getJobAndCandidateWorkLocationsMatchStatus(jobWorkLocations, this.candidate.workLocations);

    if (!this.filtersEnabled) {
      this.showFilledOrJoinedHeader = this.candidate.anyJobMatchFilledOrJoined && !this.candidate.candidateFilledOrJoinedToOwnJob;
    } else {
      this.showFilledOrJoinedHeader = (this.candidate.bestMatchJobCurrentState !== 'Filled' && this.candidate.bestMatchJobCurrentState !== 'Joined') && (this.candidate.anyJobMatchFilledOrJoined || this.candidate.candidateFilledOrJoinedToOwnJob);
    }
  }

  private _massageCandidateData(candidate: any) {
    candidate.name = this._setCandidateName(candidate);
    if (candidate.bestMatchJobRequisitionNum == null) {
      candidate.bestMatchJobRequisitionNum = '-';
    }
    if (candidate.currentJobCompanyName === null || candidate.currentJobCompanyName == '') {
      candidate.currentJobCompanyName = '-';
    }
    if (candidate.currentJobDuration === null || candidate.currentJobDuration == '') {
      candidate.currentJobDuration = '-';
    } else {
      candidate.currentJobDurationText = candidate.currentJobDuration.replace('-', ' to ');
    }
    if (candidate.currentJobLocation === null || candidate.currentJobLocation == '') {
      candidate.currentJobLocation = '-';
    }
    if (candidate.currentJobTitle === null || candidate.currentJobTitle == '') {
      candidate.currentJobTitle = '-';
    }
    candidate.currentJobCompanyNameTooltip = 'Company of Latest Job.';
    candidate.currentJobTitleTooltip = 'Title of Latest Job.';
    candidate.currentJobLocationToolTip = 'Location of Latest Job.';

    if (candidate.currentJobCompanyName.length > 30) {
      candidate.currentJobCompanyNameTooltip = candidate.currentJobCompanyNameTooltip + '- ' + candidate.currentJobCompanyName;
    }
    if (candidate.currentJobLocation.length > 30) {
      candidate.currentJobLocationToolTip = candidate.currentJobLocationToolTip + '- ' + candidate.currentJobLocation;
    }
    if (candidate.currentJobTitle.length > 30) {
      candidate.currentJobTitleTooltip = candidate.currentJobTitleTooltip + '- ' + candidate.currentJobTitle;
    }
    if (candidate.candidateStatus === 'INERT') {
      this.showCurrentJobDetails = true;
      if (candidate.currentJobCompanyName == '-' && candidate.currentJobDuration == '-' && candidate.currentJobLocation == '-' && candidate.currentJobTitle == '-') {
        this.showCurrentJobDetails = false;
      }
    }
    if (candidate.assignedRecruiterOfBestJobMatch === null) {
      candidate.bestMatchRecruiterName = '';
    } else {
      candidate.bestMatchRecruiterName = candidate.assignedRecruiterOfBestJobMatch;
    }
    if (candidate.bestMatchClientName === null) {
      candidate.bestMatchClientName = '';
    }

    if (candidate.bestJobMatchSharedClientName !== null) {
      if (candidate.bestMatchClientName == '') {
        candidate.bestMatchClientName = candidate.bestMatchClientName + ' @ ' + candidate.bestJobMatchSharedClientName;
      } else {
        candidate.bestMatchClientName = candidate.bestJobMatchSharedClientName;
      }
    }

    candidate.bestJobmatchJobLocationHtmlText = '';
    if (candidate.bestJobmatchJobLocation !== null) {
      candidate.bestJobmatchJobLocationHtmlText = this.jobService.getParsedJobLocationText(candidate.bestJobmatchJobLocation, false);
    }
    candidate.bestMatchClientName = candidate.bestMatchClientName + candidate.bestJobmatchJobLocationHtmlText;

    if (candidate.filledOrJoinedMatchClientName === null) {
      candidate.filledOrJoinedMatchClientName = '';
    }

    candidate.joinedOrFilledJobLocationHtmlText = '';
    if (candidate.joinedOrFilledJobLocation !== null) {
      candidate.joinedOrFilledJobLocationHtmlText = this.jobService.getParsedJobLocationText(candidate.joinedOrFilledJobLocation, false);
    }
    if (candidate.filledOrJoinedMatchSharedClientName !== null) {
      candidate.filledOrJoinedMatchClientName = candidate.filledOrJoinedMatchClientName + ' @ ' + candidate.filledOrJoinedMatchSharedClientName;
    }
    candidate.filledOrJoinedMatchClientName = candidate.filledOrJoinedMatchClientName + candidate.joinedOrFilledJobLocationHtmlText;

    candidate.lastModifiedDate = new Date(candidate.lastModifiedDate);
    candidate.bestMatchJobDate = new Date(candidate.bestMatchJobDate);

    if (candidate.filledOrJoinedMatchJobCurrentState == 'Joined') {
      this.hasCandidateJoined = true;
    }
    this.filledOrJoinedText = this.hasCandidateJoined ? 'Join' : 'Fill';
    if (candidate.mobilePhoneCountryCodePresent) {
      const phoneNumberObject = libphonenumber.parse(candidate.mobilephone.toString());
      if (phoneNumberObject.phone !== undefined) {
        candidate.mobilephone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
      }
    }
    if (candidate.fromOtherSource) {
      candidate.otherSourceNote = '<span>Source: Other<br>Notes: ' + candidate.otherSourceTypeNotes + '</span>';
    }
    if (this.candidateInfo.context && this.candidateInfo.context != '') {
      candidate.context = this.candidateInfo.context;
    }
    this.showAdditionalDetailsIcons = true;
    this.candidate.recruiterListMessage = 'N/A';
    if (this.candidate.recruitersList && this.candidate.recruitersList.length > 0) {
      const recruiterListMessage: string[] = [];
      this.candidate.recruitersList.map((recruiter: string, key: number) => {
        recruiterListMessage.push(`${key != 0 ? ' ' : ''}${recruiter}`);
      });
      this.candidate.recruiterListMessage = recruiterListMessage.toString();
    }
    return candidate;
  }

  private _setCandidateName(candidate: any) {
    if (candidate.firstName === null) {
      candidate.firstName = '-';
    }
    if (candidate.lastName === null) {
      candidate.lastName = '-';
    }
    if (candidate.firstName == '-' && candidate.lastName == '-') {
      candidate.nameWarning = 'First and Last Name Missing';
    } else if (candidate.firstName == '-') {
      candidate.nameWarning = 'First Name Missing';
    } else if (candidate.lastName == '-') {
      candidate.nameWarning = 'Last Name Missing';
    } else {
      candidate.nameWarning = '';
    }
    return candidate.firstName + ' ' + candidate.lastName;
  }

  private _setJobMatchesFilter(userDetails: any) {
    this.jobMatchesObject = new JobMatchQueryFilter();
    this.jobMatchesObject.candidateId = this.candidateInfo.id;
    this.jobMatchesObject.userId = userDetails.id;
    this.jobMatchesObject.companyId = userDetails.company.companyId;
    this.jobMatchesObject.top5Flag = true;
    this.jobMatchesObject.candidateType = this.candidateType;
    this.jobMatchesObject.searchText = '';
    this.jobMatchesObject.vendorIds = this.filterParams.vendors;
  }

  launchNotesModal() {
    const userDetails = this.authService.getUserDetails();
    const candidateinfo = this._setCandidateEmailSubjectAndBody(this.candidate);
    const candidateInformationList = candidateinfo.candidateInfoInEmailBody;
    const candidateDetails = {
      firstName: this.candidate.firstName,
      lastName: this.candidate.lastName,
      candidateId: this.candidate.id,
    };

    const companyDetails = {
      companyId: userDetails.company.companyId,
      companyName: userDetails.company.companyName,
      clientOrBUId: this.candidate.clientOrBUId,
      clientOrBUName: this.candidate.bestMatchClientName
    };

    const config = new ModalConfig();
    config.initialState = {
      type: 'notes',
      title: 'Notes',
      jobMatchId: this.candidate.bestMatchId,
      candidateInformationList,
      candidateDetails,
      companyDetails
    };
    config.class = 'custom-modal-xl custom-ngx-feedback-form-modal';
    config.ignoreBackdropClick = true;
    this.candidateCardNotesModal = this.modalService.show(CandidateCardActionsModalComponent, config);
  }

  launchCommunicationModal(isPeerCommunication: boolean) {
    const userDetails = this.authService.getUserDetails();
    const candidateinfo = this._setCandidateEmailSubjectAndBody(this.candidate);
    const candidateInformationList = candidateinfo.candidateInfoInEmailBody;
    const vm = this;
    const config = new ModalConfig();
    config.initialState = {
      type: isPeerCommunication ? 'communication-peer' : 'communication-candidate',
      title: isPeerCommunication ? 'Peer Communication' : 'Candidate Communication',
      candidateId: this.candidateInfo.id,
      jobMatchId: this.candidate.bestMatchId,
      jobId: this.candidate.bestMatchJobId,
      jobMatchesFilter: this.jobMatchesObject,
      candidateInformationList,
      companyId: userDetails.company.companyId,
      userId: userDetails.id,
      clientOrBUId: this.candidate.clientOrBUId,
      jobMatches: [],
      candidateType: this.candidateType
    };
    config.class = 'custom-modal-xl custom-ngx-feedback-form-modal';
    config.ignoreBackdropClick = true;
    this.candidateCardCommunicationModal = this.modalService.show(CandidateCardActionsModalComponent, config);
    this.candidateCardCommunicationModal.content.onClose.subscribe(() => {
      if (isPeerCommunication) {
        vm.refreshCard(false, false);
      }
    });
  }

  hideJobMatchesPopovers() {
    if (this.jobMatchesPopoverDirectives) {
      this.jobMatchesPopoverDirectives.forEach(popover => popover.hide());
    }
  }

  closeJobMatchesPopoverAndNavigate(type: string) {
    this.hideJobMatchesPopovers();
    this.setCandidateInfo.emit({ candidateInfo: this.candidateInfo, type });
  }

  launchActionsModal(type: string, action?: string) {
    const userDetails = this.authService.getUserDetails();
    let actionType = '';
    let actionLabel = '';
    let windowTopClass = 'four-dot-five-modal-small';
    switch (type) {
      case 'availability':
        actionType = 'availability';
        actionLabel = 'Set Candidate Availability Date';
        break;
      case 'jobLeft':
        actionType = 'jobLeft';
        actionLabel = 'Job Left';
        windowTopClass = 'four-dot-five-modal-medium';
        break;
      case 'delete':
        actionType = 'delete';
        actionLabel = 'Delete Candidate';
        break;
      case 'updateContact':
        actionType = 'updateContact';
        actionLabel = 'Update Candidate Contact Details';
        windowTopClass = 'four-dot-five-modal-medium';
        break;
      case 'profile':
        actionType = 'profile';
        actionLabel = this.candidate.name + "'s" + ' ' + 'Booklet';
        windowTopClass = 'four-dot-five-modal-large';
        break;
      case 'bestMatchJobProfile':
        actionType = 'bestMatchJobProfile';
        actionLabel = 'Best Match Job Profile';
        windowTopClass = 'four-dot-five-modal-large';
        break;
      case 'uploadResume':
        actionType = 'uploadResume';
        actionLabel = 'Upload Resume';
        windowTopClass = 'four-dot-five-modal-large';
        break;
      case 'runCandidateScore':
        actionType = 'runCandidateScore';
        actionLabel = 'Run Candidate Score';
        windowTopClass = 'four-dot-five-modal-medium';
        break;
      case 'doNotHire':
        actionType = 'doNotHire';
        actionLabel = 'Do Not Hire';
        windowTopClass = 'four-dot-five-modal-medium';
        break;
      case 'emailDocument':
        actionType = 'emailDocument';
        actionLabel = 'Send Email';
        windowTopClass = 'four-dot-five-modal-extra-large';
        break;
      case 'clientReview':
        actionType = 'clientReview';
        actionLabel = 'Client Review';
        windowTopClass = 'four-dot-five-modal-extra-large';
        break;
      case 'sendOutreach':
        actionType = 'sendOutreach';
        actionLabel = `<span>Send Outreach to Candidate <b>'${this.candidate.name}'</b></span>`;
        windowTopClass = 'four-dot-five-modal-extra-large';
        break;
      default:
        break;
    }

    if (actionType == 'delete' && (this.candidate.anyJobMatchFilledOrJoined || this.candidate.candidateFilledOrJoinedToOwnJob)) {
      const message = "Candidate <span class='emerald'>'" + this.candidate.name + "'</span> cannot be deleted as he/she is in <span class='emerald'>'" + this.filledOrJoinedText + "ed'</span> state";
      bootbox.alert({
        closeButton: false,
        title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot Delete Candidate</strong></div>",
        message,
        className: 'zIndex1060',
        buttons: {
          ok: {
            label: 'Ok',
            className: 'btn-info'
          }
        }
      });
    } else if (actionType == 'runCandidateScore') {
      this.alertsAndNotificationsService.showConfirm(actionLabel, 'Are you sure you want to run the candidate score?', 'warning', true, () => {
        const requestObject: any = new RunCandidateScore(userDetails.company.companyId, userDetails.id);
        requestObject.candidateId = this.candidate.id;
        requestObject.rerunType = 'CANDIDATE';
        requestObject.candidateType = this.candidateType;
        this.resumeService.reRunResumeScore(requestObject, (data: any) => {
          this.alertsAndNotificationsService.showAlertWithCallBack('Candidate scoring in Progress', data.message, 'success', () => { });
        }, (error: any) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }, () => {
        // do nothing
      });
    } else {
      let jobMatchId = '';
      let jobId = '';

      if ((actionType == 'jobLeft' || this.showFilledOrJoinedOnCard) && this.candidate.filledOrJoinedMatchId !== null) {
        jobId = this.candidate.filledOrJoinedMatchJobId;
        jobMatchId = this.candidate.filledOrJoinedMatchId;
      } else if (this.candidate.bestMatchId !== null) {
        jobId = this.candidate.bestMatchJobId;
        jobMatchId = this.candidate.bestMatchId;
      }

      const candidateDetails: any = {
        context: 'candidateCard',
        candidateId: this.candidate.id,
        companyId: userDetails.company.companyId,
        jobMatchId,
        hasResume: this.candidate.hasResume,
        resumeFileName: this.candidate.resumePdfFileName,
        resumeXRXml: this.candidate.resumePdfFileName ? this.candidate.resumePdfFileName.replace(/\.\w+/, '.xml') : '',
        candidateType: this.candidateType,
        showOnlyJobMatchUsers: true,
        candidateEmailSubjectAndBodyInformation: this._setCandidateEmailSubjectAndBody(this.candidate),
        vendorId: this._setCandidateVendorDetails(this.candidate),
        name: this.candidate.firstName + this.candidate.lastName
      };

      if (action === 'email') {
        candidateDetails.candidateEmail = this.candidate.email;
      } else {
        candidateDetails.candidateEmail = null;
      }

      const formalizeActivityPayload = {
        candidate: new FormalizeCandidate(this.candidate.id, this.candidate.firstName, this.candidate.lastName),
        requisition: null,
        jobMatch: null,
        company: new FormalizeCompany(userDetails.company.companyId, userDetails.company.companyName, '', '')
      };

      const vm = this;

      const config = new ModalConfig();
      const classByWindowTopClass: any = {
        'four-dot-five-modal-small': 'custom-modal-65 custom-candidate-job-match-modal',
        'four-dot-five-modal-medium': 'custom-modal-xl custom-candidate-job-match-modal',
        'four-dot-five-modal-large': 'custom-modal-xl custom-candidate-job-match-modal',
        'four-dot-five-modal-extra-large': 'custom-modal-2xl custom-candidate-job-match-modal'
      };
      config.initialState = {
        type: actionType,
        title: actionLabel,
        candidateId: this.candidateInfo.id,
        candidateName: this.candidate.name,
        bestJobMatchId: jobMatchId,
        bestMatchJobId: jobId,
        candidateInfo: {
          candidateId: this.candidateInfo.id,
          candidateName: this.candidate.name,
          jobMatchCount: this.candidate.jobMatchesCount,
          emailId: this.candidate.email,
          phoneNumber: this.candidate.mobilephone
        },
        availabilityDate: this.candidate.availabilityDate,
        joinedDate: this.candidate.filledOrJoinedMatchJobDate,
        deleteCandidateCallback: () => vm.deleteCallback.emit(),
        candidateDetails,
        salaryDurationOptions: this.salaryDurationOptions,
        jobTypeList: this.jobTypeList,
        formalizeActivityPayload,
        companyId: userDetails.company.companyId,
        userId: userDetails.id,
        clientOrBUId: this.candidate.clientOrBUId,
        jobMatches: [],
        candidateType: this.candidateType
      };
      config.class = classByWindowTopClass[windowTopClass] || 'custom-modal-xl custom-candidate-job-match-modal';
      config.ignoreBackdropClick = true;
      this.candidateCardActionsModal = this.modalService.show(CandidateCardActionsModalComponent, config);
      this.candidateCardActionsModal.content.onClose.subscribe((result: any) => {
        if (result && actionType == 'uploadResume') {
          vm.refreshCard(false, false);
        } else if (result && (actionType == 'updateContact' || actionType == 'availability' || actionType == 'jobLeft' || actionType == 'doNotHire' || actionType == 'clientReview')) {
          vm.refreshCard((actionType === 'jobLeft' || actionType == 'updateContact' || actionType == 'clientReview'), (actionType === 'jobLeft' || actionType == 'updateContact'));
        }
      });
    }
  }

  showAllActivityModal() {
    const config = new ModalConfig();
    config.initialState = {
      type: 'activities',
      title: 'Candidate Activity',
      candidateInfo: this.candidate,
      activityMap: this.activityMap
    };
    config.class = 'custom-modal-xl custom-candidate-job-match-modal';
    this.candidateCardShowAllActivitiesModal = this.modalService.show(CandidateCardActionsModalComponent, config);
  }

  refreshCard(refreshWithoutFilters: boolean, refreshJobMatches: boolean) {
    this.showNotificationsFlag = false;
    this.showRecentActivitiesFlag = false;
    setTimeout(() => {
      this.init(refreshWithoutFilters);
      if (refreshJobMatches) {
        this._refreshJobMatches();
      }
    }, 300);
  }

  private _refreshJobMatches() {
    this.sharedAjsService.raiseRefreshJobMatchesEvent(this.candidateInfo.id, this.jobMatchesActiveTab.type);
  }

  showRecentActivities() {
    this.recentActivitiesControls.activityClickCount++;
    this.isActivityClicked = !this.isActivityClicked;
  }

  showNotifications() {
    this.userNotificationControls.notificationClickCount++;
    this.isNotificationClicked = !this.isNotificationClicked;
  }

  trackByIndex(index: number) {
    return index;
  }

  private _setCandidateEmailSubjectAndBody(candidate: any) {
    const candidateInformation: any = {};
    candidateInformation.subject = `Candidate Information: ${candidate.name}`;
    candidateInformation.body = '';
    candidate.candidateAdditionalDetailsCard.preferredWorkLocations = this.candidate.workLocations;
    candidateInformation.candidateInfoInEmailBody = this.jobMatchActionsService._setCandidateInfoInEmailBody(candidate, candidate.candidateAdditionalDetailsCard);
    return candidateInformation;
  }

  private _setCandidateVendorDetails(candidate: any) {
    let vendorId = null;
    if (candidate.vendorName && this.allVendors) {
      this.allVendors.map((vendor: any) => {
        if (vendor.name == candidate.vendorName) {
          vendorId = vendor.id;
        }
      });
    }
    return vendorId;
  }

}
